import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'

const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 70 70' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M55.4167 37.9166H14.5833C11.3617 37.9166 8.75 40.5283 8.75 43.75V52.5C8.75 55.7216 11.3617 58.3333 14.5833 58.3333H55.4167C58.6383 58.3333 61.25 55.7216 61.25 52.5V43.75C61.25 40.5283 58.6383 37.9166 55.4167 37.9166Z'
            fill='#0D1537'
        />
        <path
            d='M50.7588 27.8515L46.2582 31.5627C43.502 28.2202 39.4153 26.25 35.0002 26.25C30.5995 26.25 26.5249 28.2072 23.7684 31.531L19.2783 27.8072C23.1315 23.161 28.8448 20.4167 35.0002 20.4167C41.1758 20.4167 46.9059 23.1792 50.7588 27.8515ZM59.699 20.3551L55.2102 24.0806C50.2505 18.1046 42.916 14.5833 35.0002 14.5833C27.0952 14.5833 19.7699 18.0948 14.81 24.0566L10.3257 20.3258C16.3824 13.0457 25.3437 8.75 35.0002 8.75C44.67 8.75 53.6424 13.0577 59.699 20.3551Z'
            fill='#52BD95'
        />
    </svg>
)

export default SVG
